import { gql, useQuery } from '@apollo/client';
import { BubbleRecommendations } from '@xp-utilities/web';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './BubbleRecommendationsWrapper.module.scss';

const FEATURE_FLAG_QUERY = gql`
  query FeatureFlagForBubbleRecommendations($queryId: String!) {
    config {
      featureFlag: nonCachedGenericType(name: $queryId)
    }
  }
`;

export default function BubbleRecommendationsWrapper({
  placementIds = [],
  queryId,
  skipQuery = false,
  testId = 'bubbles-recommendations-wrapper',
}) {
  const { data } = useQuery(FEATURE_FLAG_QUERY, {
    skip: skipQuery || !queryId,
    variables: { queryId },
  });

  const isFlagEnabled = data?.config?.featureFlag?.value ?? false;

  return (
    placementIds.length > 0 && (isFlagEnabled || skipQuery) ? (
      <section className={styles.bubbleRecommendationsWrapper} data-testid={testId}>
        <BubbleRecommendations
          className={queryId ? styles[queryId] : ''}
          fetchRecommendations
          placements={placementIds}
        />
      </section>
    ) : null
  );
}

BubbleRecommendationsWrapper.propTypes = {
  placementIds: PropTypes.arrayOf(PropTypes.string),
  queryId: PropTypes.string,
  skipQuery: PropTypes.bool,
  testId: PropTypes.string,
};
